




















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';

// Components
import Group from './InvolvedInsuredsHealthCareProviders-Group.vue';
import Provider from './InvolvedInsuredsHealthCareProviders-Provider.vue';

@Component({
	name: 'InvolvedInsuredsHealthCareProvidersFields',
	components: {
		Group,
		Provider,
	},
})
export default class InvolvedInsuredsHealthCareProvidersFields extends Vue {
	@Prop() private values: any;
	@Prop() private input: any;
	@Prop() private blur: any;
	@Prop() private errors: any;
	@Prop() private touched: any;
}
